import { render } from "./Header.vue?vue&type=template&id=0555837e&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=0555837e&scoped=true&lang=css"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0555837e"]])

export default __exports__